import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Card, CardBody, Modal } from "reactstrap";
import { deleteCategory, getCategory } from "../../../redux/category/action";
import { useNavigate } from "react-router-dom";
import {
  getGenderText,
  getStatusColor,
  getStatusText,
} from "../../Common/Utils/statusUtils";
import "../../Common/Styles/Listing.css";
import search from "../../assets/images/search-lg.svg";
import Filter from "../../Common/Filter/Filter";
import CardHeader from "../../Common/CardHeader/CardHeader";
import ModalDelete from "../../Common/Popup/ModalDelete";
import CommonPagination from "../../Common/Pagination/CommonPagination";
import CategoryFilter from "./CategoryFilter";

const CategoryList = () => {
  const [params, setParams] = useState({
    page: 1,
    search_key: "",
    status: "",
    type:1
  });
  const [openFilter, setOpenFilter] = useState(false);
  const [modal, setModal] = useState(false);
  const [currentComponent, setCurrentComponent] = useState({});
  const [loading, setLoading] = useState(false);
  const [componentList, setComponentList] = useState([]);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const category = useSelector(
    ({ category: { categorylist } }) => categorylist,
  );

  useEffect(() => {
    dispatch(getCategory(params));
  }, [params, dispatch]);

  useEffect(() => {
    if (category && Array.isArray(category.categories)) {
      setComponentList(category.categories);
    } else {
      setComponentList([]);
    }
  }, [category]);

  const deleteComponent = () => {
    if (currentComponent && currentComponent.id) {
      dispatch(deleteCategory(currentComponent.id, setLoading, params));
    } else {
      console.error("No valid ID found for the component to delete.");
    }
  };

  const addComponent = () => {
    navigate("/category/add");
  };

  const updateComponent = (id) => {
    navigate(`/category/update/${id}`);
  };

  return (
    <Card className="">
      <div
        onClick={() => setOpenFilter(false)}
        className={openFilter ? "overlay show" : "overlay"}
      ></div>
      <CategoryFilter
        openFilter={openFilter}
        setOpenFilter={setOpenFilter}
        params={params}
        setParams={setParams}
      />
      <CardHeader
        params={params}
        setParams={setParams}
        addmodel={addComponent}
        search={search}
        setOpenFilter={setOpenFilter}
      />
      <CardBody className="table-sec px-3">
        <table className="table">
          <thead>
            <tr>
              <th scope="col">#</th>
              <th scope="col">Title</th>
              <th scope="col">Business Count</th>
              <th scope="col">Gender</th>
              <th scope="col">Status</th>
              <th scope="col">Position</th>
              <th scope="col" className="text-center">Action</th>
            </tr>
          </thead>
          <tbody>
            {componentList.length > 0 ? (
              componentList.map((item, index) => (
                <tr key={item.id}>
                  <td> {index + 1 + (params?.page - 1) * 10}</td>
                  <td>{item?.title}</td>
                  <td>{item?.business_count}</td>
                  <td>{getGenderText(item?.gender)}</td>
                  <td>
                    <span style={{ color: getStatusColor(item?.status) }}>
                      {getStatusText(item?.status)}
                    </span>
                  </td>
                  <td >{item?.position}</td>
                  <td>
                    <div
                      className="d-flex align-items-center justify-content-center"
                      style={{ columnGap: "10px" }}
                    >
                      <button
                        className="border-button"
                        onClick={() => updateComponent(item.id)}
                      >
                        <span>Update</span>
                      </button>
                      <button
                        className="background-button"
                        onClick={() => {
                          setModal(true);
                          setCurrentComponent(item);
                        }}
                      >
                        <span>Delete</span>
                      </button>
                    </div>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="7" className="text-center">
                  No categories found
                </td>
              </tr>
            )}
          </tbody>
        </table>
        <CommonPagination
          params={params}
          setParams={setParams}
          pagination_meta={category?.pagination_meta}
        />
      </CardBody>
      <Modal isOpen={modal} toggle={() => setModal((state) => !state)}>
        <ModalDelete
          itemType="Category"
          modalTitle="Category"
          setModal={setModal}
          currentComponent={currentComponent}
          deleteComponent={deleteComponent}
        />
      </Modal>
    </Card>
  );
};

export default CategoryList;
